import React from 'react';

interface AssetDistributionOptionProps {
  id: string;
  label: string;
  description: string;
  value: string;
  name?: string;
}

export function AssetDistributionOption({ id, label, description, value, name }: AssetDistributionOptionProps) {
  const groupName = name || 'asset-distribution';

  return (
    <div className="asset-distribution-option">
      <input type="radio" id={id} name={groupName} value={value} />
      <div className="asset-distribution-content">
        <h4>{label}</h4>
        <h6>{description}</h6>
      </div>
    </div>
  );
}
